import React from 'react';
import { Users, CreditCard, AlertTriangle, Building2 } from 'lucide-react';
import type { AnalyticsKPIs as AnalyticsKPIsType } from '../../services/api';

interface AnalyticsKPIsProps {
    data?: AnalyticsKPIsType;
    isLoading?: boolean;
}

const AnalyticsKPIs: React.FC<AnalyticsKPIsProps> = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <div className="analytics-kpi-grid">
                {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="kpi-card skeleton">
                        <div className="skeleton-icon" />
                        <div className="skeleton-content">
                            <div className="skeleton-label" />
                            <div className="skeleton-value" />
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    const kpis = [
        {
            label: 'Registered Companies',
            value: data?.companiesStatistics || 0,
            icon: <Building2 className="kpi-icon companies" />,
            color: 'blue'
        },
        {
            label: 'Total Cards Issued',
            value: data?.userIssuanceRecords || 0,
            icon: <CreditCard className="kpi-icon issued" />,
            color: 'green'
        },
        {
            label: 'Pending Card Requests',
            value: data?.cardRequests || 0,
            icon: <Users className="kpi-icon requests" />,
            color: 'orange'
        },
        {
            label: 'Flagged Transactions',
            value: data?.flaggedTransactions || 0,
            icon: <AlertTriangle className="kpi-icon flagged" />,
            color: 'red'
        }
    ];

    return (
        <div className="analytics-kpi-grid">
            {kpis.map((kpi, index) => (
                <div key={index} className={`kpi-card ${kpi.color}`}>
                    <div className="kpi-icon-wrapper">
                        {kpi.icon}
                    </div>
                    <div className="kpi-content">
                        <span className="kpi-label">{kpi.label}</span>
                        <span className="kpi-value">{kpi.value.toLocaleString()}</span>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default AnalyticsKPIs;
